<template>
  <button
    class="button-interactive rounded-full shadow-md text-error-500 p-1.5 hover:bg-error-500 hover:text-white w-8 h-8 flex justify-center items-center"
  >
    <delete-icon class="w-5 fill-current" />
  </button>
</template>